"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockType = void 0;
/**
 * Type of block
 */
var BlockType;
(function (BlockType) {
    BlockType["PrimaryCollection"] = "PrimaryCollection";
    BlockType["Primary"] = "Primary";
    BlockType["Footer"] = "Footer";
    BlockType["FooterWidget"] = "FooterWidget";
    BlockType["Header"] = "Header";
    BlockType["NavWidget"] = "NavWidget";
    BlockType["Secondary"] = "Secondary";
    BlockType["Tertiary"] = "Tertiary";
})(BlockType = exports.BlockType || (exports.BlockType = {}));
